<div class="container">
    <form [formGroup]="formulario">

        <div class="row pt-3">
            <div class="col-lg-12 col-md-12">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Híbrido RNC/Linhagem</mat-label>
                    <!-- <input matInput name="hibrido_rnc" formControlName="hibrido_rnc"
                        maxlength="20" #txtHibrido id="txtHibrido"> -->
                         <!--[matAutocomplete]="auto2"-->

                        <mat-select formControlName="hibrido_rnc" multiple>

                          <mat-option *ngFor="let item of filteredOptionsHibrido | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                        </mat-select>

                   <!-- <mat-autocomplete #auto2="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsHibrido | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-autocomplete> -->
                    <!-- <mat-hint align="end">{{txtHibrido.value.length}} / 20</mat-hint> -->
                </mat-form-field>
            </div>
            
        </div>
        <div class="row">
            <div class="col-lg col-md text-right">
                <button mat-flat-button color="primary" matTooltip="Limpar" class="textoGeral mr-1 btnSize"
                    (click)="clearFilter()"><i class="fa fa-paint-brush fa-1x btnIcon"></i> Limpar</button>
                <button mat-flat-button color="primary" matTooltip="Pesquisar" class="textoGeral mr-1 btnSize"
                    (click)="sendFilter()"><i class="fa fa-search fa-1x btnIcon"></i> Pesquisar</button>
            </div>
        </div>

    </form>
</div>
